"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MetaSpiritualityDeferredAction = void 0;
const AndOptions_1 = require("../inputs/AndOptions");
const SelectAmount_1 = require("../inputs/SelectAmount");
const DeferredAction_1 = require("./DeferredAction");
const Resources_1 = require("../Resources");
class MetaSpiritualityDeferredAction {
    constructor(player, count = 1, title = 'Meta Spirituality Global Event - Gain ' + count + ' standard resource(s)') {
        this.player = player;
        this.count = count;
        this.title = title;
        this.priority = DeferredAction_1.Priority.DEFAULT;
    }
    execute() {
        let megacreditsAmount = this.count >= 6 ? 1 : 0;
        let steelAmount = this.count >= 6 ? 1 : 0;
        let titaniumAmount = this.count >= 6 ? 1 : 0;
        let plantsAmount = this.count >= 6 ? 1 : 0;
        let energyAmount = this.count >= 6 ? 1 : 0;
        let heatAmount = this.count >= 6 ? 1 : 0;
        const amounts = [megacreditsAmount, steelAmount, titaniumAmount, plantsAmount, energyAmount, heatAmount];
        const minSelectionPerResource = Math.floor(this.count / 6);
        const maxSelectionPerResource = Math.ceil(this.count / 6);
        const selectMegacredit = new SelectAmount_1.SelectAmount('Megacredits', 'Select', (amount) => {
            megacreditsAmount = amount;
            return undefined;
        }, minSelectionPerResource, maxSelectionPerResource);
        const selectSteel = new SelectAmount_1.SelectAmount('Steel', 'Select', (amount) => {
            steelAmount = amount;
            return undefined;
        }, minSelectionPerResource, maxSelectionPerResource);
        const selectTitanium = new SelectAmount_1.SelectAmount('Titanium', 'Select', (amount) => {
            titaniumAmount = amount;
            return undefined;
        }, minSelectionPerResource, maxSelectionPerResource);
        const selectPlants = new SelectAmount_1.SelectAmount('Plants', 'Select', (amount) => {
            plantsAmount = amount;
            return undefined;
        }, minSelectionPerResource, maxSelectionPerResource);
        const selectEnergy = new SelectAmount_1.SelectAmount('Energy', 'Select', (amount) => {
            energyAmount = amount;
            return undefined;
        }, minSelectionPerResource, maxSelectionPerResource);
        const selectHeat = new SelectAmount_1.SelectAmount('Heat', 'Select', (amount) => {
            heatAmount = amount;
            return undefined;
        }, minSelectionPerResource, maxSelectionPerResource);
        const selectResources = new AndOptions_1.AndOptions(() => {
            if (megacreditsAmount +
                steelAmount +
                titaniumAmount +
                plantsAmount +
                energyAmount +
                heatAmount > this.count) {
                throw new Error('Need to select ' + this.count + ' resource(s)');
            }
            if (Math.min(...amounts) < minSelectionPerResource) {
                throw new Error('Must select at least ' + minSelectionPerResource + ' of each resource');
            }
            if (Math.max(...amounts) > maxSelectionPerResource) {
                throw new Error('Can select at most ' + maxSelectionPerResource + ' of each resource');
            }
            this.player.addResource(Resources_1.Resources.MEGACREDITS, megacreditsAmount, { log: true });
            this.player.addResource(Resources_1.Resources.STEEL, steelAmount, { log: true });
            this.player.addResource(Resources_1.Resources.TITANIUM, titaniumAmount, { log: true });
            this.player.addResource(Resources_1.Resources.PLANTS, plantsAmount, { log: true });
            this.player.addResource(Resources_1.Resources.ENERGY, energyAmount, { log: true });
            this.player.addResource(Resources_1.Resources.HEAT, heatAmount, { log: true });
            return undefined;
        }, selectMegacredit, selectSteel, selectTitanium, selectPlants, selectEnergy, selectHeat);
        selectResources.title = this.title;
        return selectResources;
    }
}
exports.MetaSpiritualityDeferredAction = MetaSpiritualityDeferredAction;
//# sourceMappingURL=MetaSpiritualityDeferredAction.js.map